module.exports = __webpack_public_path__ + "static/img/login_a1.c20008b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/login_a1.png
// module id = yaX4
// module chunks = 23